var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndex3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#index3_svg__clip0_247_28396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 018-8h16v16a8 8 0 01-8 8H0V8z",
    fill: "#000",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.985 12.817v-1.174h.457c.453 0 .804-.125 1.054-.375.25-.241.374-.554.374-.94-.008-.389-.137-.708-.387-.958-.25-.241-.571-.366-.965-.374-.283 0-.541.09-.774.273-.245.182-.41.463-.495.844H8.922a2.702 2.702 0 01.832-1.733 2.418 2.418 0 011.713-.711c.843.008 1.511.277 2.006.806.474.516.716 1.126.724 1.828 0 .356-.063.698-.19 1.028-.149.33-.413.625-.794.883.39.254.67.559.844.914.165.355.248.728.248 1.117-.008.868-.277 1.551-.806 2.05-.52.512-1.19.773-2.006.781a2.54 2.54 0 01-1.676-.61c-.487-.405-.802-.994-.946-1.764h1.327c.118.31.286.559.502.75.22.198.511.297.875.297.39 0 .718-.133.984-.4.271-.25.41-.604.42-1.066-.01-.47-.149-.833-.42-1.092-.266-.25-.605-.374-1.015-.374h-.559z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "index3_svg__clip0_247_28396"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgIndex3;